const ConfirmationModal = ({
  onClose,
  onConfirm,
  icon,
  title,
  message,
  theme,
  button = "ok",
}) => {
  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      style={{
        display: "block",
        background: "rgba(0, 0, 0, 0.5)",
      }}
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
    >
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="comfirmation-content-modal">
          <div className="">
            <button
              type="button"
              className="btn-close-confirmation"
              onClick={onClose}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button>

            <div className="d-flex flex-column align-items-center text-center gap-3">
              <div>
                <i
                  className={icon}
                  style={{ fontSize: "40px", color: theme }}
                  aria-hidden="true"
                ></i>
              </div>
              {title && (
                <h6 className="text-dark confirm-modal-title mb-1">{title}</h6>
              )}
              {message && (
                <p className="text-dark mb-0" style={{ maxWidth: "300px" }}>
                  {message}
                </p>
              )}
            </div>
            <hr />
            {button === "ok" && (
              <div className="d-flex justify-content-end gap-3">
                <button className="btn orngbtn" onClick={onClose}>
                  Got it
                </button>
              </div>
            )}
            {button === "yes" && (
              <div className="d-flex justify-content-end gap-3">
                <button className="btn btn-primary" onClick={onConfirm}>
                  Yes
                </button>
                <button className="btn orngbtn" onClick={onClose}>
                  No
                </button>
              </div>
            )}
            {button === "confirm" && (
              <div className="d-flex justify-content-end gap-3">
                <button className="btn btn-primary">Confirm</button>
                <button className="btn orngbtn">Cancel</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
